// src/utils/lang.js
// — Κανονικοποίηση κωδικών i18n (case, aliases) —
export const canonicalI18n = (code = "en") => {
  const c = String(code).trim();
  const lo = c.toLowerCase();
  if (lo === "gr" || lo === "el-gr") return "el";
  if (lo === "sq") return "al";
  if (lo === "en-gb") return "en-GB";
  if (lo === "en-us") return "en-US";
  // αν υπάρχει ήδη στα resources ως ακριβής κωδικός (el, en, fr, ...), κράτα το όπως είναι:
  // προτίμησε να επιστρέψεις όπως το έχεις στα json: el, en, en-GB, en-US, fr, de, ...
  // Για απλά 2-γράμματα επέστρεψε lower-case:
  if (/^[a-z]{2}$/.test(lo)) return lo;
  return c; // π.χ. "en-GB" ήδη σωστό, "en-US" ήδη σωστό
};

// — Τι μπαίνει στο URL prefix —
// Εδώ θέλεις locale path (π.χ. en, en-us, en-gb, el, fr, de, zh, ...).
export const pathLangFrom = (code = "en") => {
  const canon = canonicalI18n(code);
  const lo = canon.toLowerCase().replace("_", "-");
  if (lo === "gr" || lo === "el-gr") return "el";
  if (lo === "en-us" || lo === "en-gb") return lo;
  return lo.split("-")[0]; // primary (zh-CN -> zh)
};

// — Οι γλώσσες που έχεις όντως σε αρχεία json / i18n resources —
// (Βάλε εδώ όσες υποστηρίζεις: el, en, fr, de, es, sv, ar, ur, it, ru, sr, hr, ro, sq, bg, zh)
export const SUPPORTED_PATHS = new Set([
  "el", "en", "en-us", "en-gb",
  "al", "ar", "bg", "de", "es", "fr", "hr", "hu", "it",
  "mk", "ro", "ru", "sq", "sr", "sv", "ur", "zh"
]);

export const backendLangFromI18n = (code = "en") => {
  const canon = canonicalI18n(code);        // π.χ. "en", "en-GB", "el", "zh"
  const lo = canon.toLowerCase();

  if (lo === "gr") return "el";
  if (lo === "en-gb") return "en_gb";
  if (lo === "en-us") return "en_us";
  if (lo.startsWith("zh")) return "zh";     // ενοποιούμε zh-* σε zh

  // γενικός κανόνας: en-xx -> en_xx
  return lo.replace("-", "_");
};
export const isSupportedPathLang = (seg = "") => SUPPORTED_PATHS.has(String(seg).toLowerCase());
